import {combineReducers} from "redux";
import {userReducers} from "./userReducers";

export type RootType = ReturnType<typeof rootReducers>;
export const rootReducers = combineReducers({
  userReducers
})
